/**
 * Archive Grid PJAX
 *
 * Intercepts filter, sort, view-mode, and pagination interactions inside
 * .bfwt-pjax-container and replaces its content via fetch() instead of
 * a full page reload.  The browser URL is updated with history.pushState()
 * so GA / analytics and bookmarks work as expected.
 *
 * On page-refresh or direct URL load the server renders the correct state
 * from URL params — no JS needed for initial render.
 */

(function () {
  'use strict';

  const CONTAINER_SEL = '.bfwt-pjax-container';
  const LOADING_CLASS = 'is-loading';
  const VIEW_STORAGE_KEY = 'bfwt_view_mode';

  // ── BudgetFitter Signature Header-Bottom Northern Lights Aura & >B Stroke Loader ──
  const BFWT_EXACT_LOGO_PATHS =
    '<path d="m162.64 122.73 22.568-119.39c8.736-1.82 20.202-2.912 32.214-2.912 12.922 0 22.204 1.638 30.394 6.37 8.19 4.186 14.196 12.194 14.196 22.568 0 15.47-11.284 25.298-24.752 29.12v0.546c11.83 3.64 19.292 13.286 19.292 26.754 0 13.286-7.098 22.75-16.744 29.12-10.374 7.098-25.844 10.01-46.228 10.01-13.832 0-24.934-0.91-30.94-2.184zm45.136-101.19-5.46 28.574h8.736c14.378 0 24.206-6.188 24.206-16.744 0-8.736-7.098-12.558-17.108-12.558-4.55 0-8.372 0.364-10.374 0.728zm-9.464 47.684-6.552 34.762c3.094 0.364 6.188 0.364 10.01 0.364 14.196 0 27.118-5.642 27.118-19.292 0-12.194-10.192-15.834-22.386-15.834h-8.19z"/>' +
    '<path d="m6.464 118.06c-1.9671-1.967-3.5368-4.274-4.709-6.922-1.1731-2.648-1.7581-5.539-1.755-8.671l0.05578-80.272c-0.030993-3.1759 0.54843-6.087 1.7383-8.7335 1.1908-2.6474 2.7785-4.9635 4.7632-6.9482 1.9838-1.9838 4.3031-3.5748 6.9579-4.7729 2.6548-1.1982 5.5655-1.7771 8.7321-1.7369l98.495 0.20838c2.948-0.003023 5.775 0.56446 8.481 1.7024 2.704 1.1371 5.082 2.7302 7.131 4.7795l40.001 40.001c4.387 4.3875 6.586 9.5945 6.597 15.621 0.011 6.0275-2.195 11.253-6.619 15.678l-40.269 40.269c-2.114 2.114-4.536 3.723-7.266 4.826-2.728 1.104-5.536 1.663-8.422 1.678l-98.282-0.207c-3.1269 9e-3 -6.022-0.581-8.6853-1.769-2.6633-1.187-4.978-2.764-6.9442-4.731zm15.712-15.675 98.452-0.029 40-40-39.935-39.935-98.427-0.207-0.0903 80.171z"/>';

  const BFWT_SIGNATURE_SVG =
    '<svg class="bfwt-signature-loader__svg" viewBox="0 0 263 125" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<defs>' +
    '<linearGradient id="bfwt-b-stroke-grad" x1="0%" y1="0%" x2="100%" y2="100%">' +
    '<stop offset="0%" stop-color="#04875D"/><stop offset="40%" stop-color="#10B981"/><stop offset="72%" stop-color="#34D399"/><stop offset="100%" stop-color="#38BDF8"/>' +
    '</linearGradient>' +
    '<clipPath id="bfwt-b-exact-clip">' + BFWT_EXACT_LOGO_PATHS + '</clipPath>' +
    '</defs>' +
    '<g class="bfwt-signature-loader__track">' + BFWT_EXACT_LOGO_PATHS + '</g>' +
    '<g clip-path="url(#bfwt-b-exact-clip)">' +
    '<path class="bfwt-signature-loader__stroke bfwt-signature-loader__stroke--tag" style="stroke-width:30" pathLength="100" d="M124 11.2 H18 C13 11.2 11.1 13.5 11.1 18 V106.5 C11.1 111 13 113.5 18 113.5 H124 L171.5 62.3 Z"/>' +
    '<path class="bfwt-signature-loader__stroke bfwt-signature-loader__stroke--b" style="stroke-width:30" pathLength="100" d="M174 122 L196 10.5 H222 C244 10.5 250 20 248 33.5 C246 47 232 57.5 212 59.5 H192 L215 59.5 C238 61 246 71 243 86.5 C240 104 224 114.5 196 114.5 H168"/>' +
    '</g>' +
    '</svg>';

  window.BFWT_SignatureLoaderHtml = function (label, inlineOnly) {
    const text = label || 'Loading more';
    if (inlineOnly) {
      return BFWT_SIGNATURE_SVG + '<span class="bfwt-signature-loader__label">' + text + '</span>';
    }
    return (
      '<div class="bfwt-signature-loader" role="status" aria-live="polite">' +
      '<div class="bfwt-signature-loader__pill">' +
      BFWT_SIGNATURE_SVG +
      '<span class="bfwt-signature-loader__label">' + text + '</span>' +
      '</div></div>'
    );
  };

  let auraActiveCount = 0;
  let auraShownAt = 0;
  let auraHideTimer = null;
  function ensureAuraEl() {
    let el = document.getElementById('bfwt-edge-aura-overlay');
    const host = document.getElementById('masthead') || document.body;
    if (!el && host) {
      el = document.createElement('div');
      el.id = 'bfwt-edge-aura-overlay';
      el.className = 'bfwt-edge-aura-overlay';
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = '<div class="bfwt-edge-aura-overlay__frame"><div class="bfwt-edge-aura-overlay__beam"></div></div>';
      host.appendChild(el);
    }
    return el;
  }

  window.BFWT_EdgeAura = {
    show: function () {
      if (auraHideTimer) {
        clearTimeout(auraHideTimer);
        auraHideTimer = null;
      }
      if (auraActiveCount === 0) {
        auraShownAt = Date.now();
      }
      auraActiveCount++;
      const el = ensureAuraEl();
      if (el) el.classList.add('is-active');
    },
    hide: function (delayMs) {
      auraActiveCount = Math.max(0, auraActiveCount - 1);
      if (auraActiveCount === 0) {
        const elapsed = Date.now() - auraShownAt;
        const minPeak = typeof delayMs === 'number' ? delayMs : 520;
        const wait = Math.max(120, minPeak - elapsed);
        auraHideTimer = setTimeout(function () {
          if (auraActiveCount === 0) {
            const el = document.getElementById('bfwt-edge-aura-overlay');
            if (el) el.classList.remove('is-active');
          }
        }, wait);
      }
    },
  };


  // ── Helpers ──
  function getScrollTarget(container) {
    const bar = container.querySelector('.bfwt-filter-bar');
    if (bar && bar.id) return document.getElementById(bar.id);
    // Fall back to parent section
    return container.closest('.bfwt-content-block') || container;
  }

  function scrollToTarget(container) {
    const el = getScrollTarget(container);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 80; // 80px offset for sticky header
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  // ── Skeleton helpers ──
  function getSkeletonOrientation(preset) {
    return /listing|compact/.test(preset) ? 'horizontal' : 'vertical';
  }

  function buildSkeletonCard(orientation) {
    return (
      '<div class="bfwt-grid-item"><div class="bfwt-skeleton-grid-card bfwt-skeleton-grid-card--' +
      orientation +
      '"><div class="bfwt-skeleton-grid-card__image"></div>' +
      '<div class="bfwt-skeleton-grid-card__body">' +
      '<div class="bfwt-skeleton-grid-card__line bfwt-skeleton-grid-card__line--title"></div>' +
      '<div class="bfwt-skeleton-grid-card__line bfwt-skeleton-grid-card__line--text"></div>' +
      '<div class="bfwt-skeleton-grid-card__line bfwt-skeleton-grid-card__line--short"></div>' +
      '</div></div></div>'
    );
  }

  function showSkeletons(container) {
    const grid = container.querySelector('.bfwt-results-grid');
    if (!grid) {
      container.classList.add(LOADING_CLASS);
      return;
    }
    const inner = grid.querySelector('.bfwt-grid-inner');
    if (!inner) {
      container.classList.add(LOADING_CLASS);
      return;
    }
    const preset = grid.dataset.preset || '';
    const orientation = getSkeletonOrientation(preset);
    const count = inner.querySelectorAll('.bfwt-grid-item').length || 6;
    let html = '';
    for (let i = 0; i < count; i++) html += buildSkeletonCard(orientation);
    inner.innerHTML = html;
    container.classList.add(LOADING_CLASS);
  }

  // ── Core fetch + swap ──
  let currentAbortController = null;

  function pjaxNavigate(url, container, opts = {}) {
    // Abort any in-flight request
    if (currentAbortController) currentAbortController.abort();
    currentAbortController = new AbortController();

    const pjaxId = container.dataset.pjaxId;
    const isAppend = Boolean(opts.append);

    if (window.BFWT_EdgeAura) window.BFWT_EdgeAura.show();
    if (isAppend) {
      container.classList.add(LOADING_CLASS);
      const loadMoreBtn = container.querySelector('.bfwt-load-more-btn');
      if (loadMoreBtn) {
        loadMoreBtn.classList.add('is-loading');
        loadMoreBtn.style.pointerEvents = 'none';
        if (window.BFWT_SignatureLoaderHtml) {
          loadMoreBtn.innerHTML = window.BFWT_SignatureLoaderHtml('Loading more', true);
        }
      }
    } else {
      showSkeletons(container);
    }

    const reqHeaders = { 'X-PJAX': '1' };
    if (isAppend) reqHeaders['X-PJAX-Append'] = '1';

    fetch(url, {
      signal: currentAbortController.signal,
      credentials: 'same-origin',
      headers: reqHeaders,
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        // Parse only the matching container from the response
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newContainer = doc.querySelector(
          '[data-pjax-id="' + CSS.escape(pjaxId) + '"]'
        );
        if (!newContainer) {
          // Fallback: full reload  (edge-case, e.g. layout change)
          window.location.href = url;
          return;
        }

        if (doc.title) {
          document.title = doc.title;
        }

        if (isAppend) {
          const curInner = container.querySelector('.bfwt-results-grid .bfwt-grid-inner');
          const newInner = newContainer.querySelector('.bfwt-results-grid .bfwt-grid-inner');
          if (curInner && newInner) {
            Array.from(newInner.children).forEach(function (child) {
              if (
                child.classList.contains('bfwt-grid-item--sponsored') &&
                curInner.querySelector('.bfwt-grid-item--sponsored')
              ) {
                return;
              }
              const postId = child.getAttribute('data-post-id');
              if (
                postId &&
                curInner.querySelector('[data-post-id="' + CSS.escape(postId) + '"]')
              ) {
                return;
              }
              curInner.appendChild(child);
            });
          } else {
            container.innerHTML = newContainer.innerHTML;
          }
          const curPag = container.querySelector('.bfwt-pagination-container');
          const newPag = newContainer.querySelector('.bfwt-pagination-container');
          if (curPag && newPag) {
            curPag.outerHTML = newPag.outerHTML;
          } else if (curPag && !newPag) {
            curPag.remove();
          }
        } else {
          // Swap inner content
          container.innerHTML = newContainer.innerHTML;

          // Also swap the docked Archive Hero and dynamic tail sections when navigating between subcategories/filters
          const curHero = document.querySelector('.bfwt-archive-hero');
          const newHero = doc.querySelector('.bfwt-archive-hero');
          if (curHero && newHero) {
            curHero.outerHTML = newHero.outerHTML;
          }
          const curTail = document.getElementById('bfwt-archive-dynamic-tail');
          const newTail = doc.getElementById('bfwt-archive-dynamic-tail');
          if (curTail && newTail) {
            curTail.innerHTML = newTail.innerHTML;
          }
        }
        container.classList.remove(LOADING_CLASS);
        if (window.BFWT_EdgeAura) window.BFWT_EdgeAura.hide(280);

        // Copy dataset values from new container
        if (newContainer.dataset.currentView) {
          container.dataset.currentView = newContainer.dataset.currentView;
        }
        if (newContainer.dataset.defaultView) {
          container.dataset.defaultView = newContainer.dataset.defaultView;
        }

        // Update URL
        if (opts.push !== false) {
          history.pushState({ pjax: true, pjaxId: pjaxId }, '', url);
        }

        // Persist view mode
        const activeBtn = container.querySelector(
          '.bfwt-filter-bar__view-btn.is-active'
        );
        const currentView = activeBtn
          ? activeBtn.dataset.view
          : container.dataset.currentView || 'vertical';
        try {
          sessionStorage.setItem(VIEW_STORAGE_KEY, currentView);
        } catch (e) {}

        // Re-bind events on new content
        bindContainer(container);

        // Fire a custom event for GA / other scripts
        document.dispatchEvent(
          new CustomEvent('bfwt:pjax:load', {
            detail: { url: url, containerId: pjaxId },
          })
        );

        // Scroll
        if (opts.scroll !== false) scrollToTarget(container);
      })
      .catch(function (err) {
        if (window.BFWT_EdgeAura) window.BFWT_EdgeAura.hide(100);
        if (err.name === 'AbortError') return; // expected
        container.classList.remove(LOADING_CLASS);
        // On error, fall back to normal navigation
        window.location.href = url;
      });
  }

  // ── Event binding ──
  function bindContainer(container) {
    // 1. Filter links  (toggle chips, reset, view-mode links)
    container
      .querySelectorAll(
        '.bfwt-filter-bar__toggle, .bfwt-filter-bar__reset, .bfwt-filter-bar__view-btn'
      )
      .forEach(function (link) {
        if (link.dataset.pjaxBound) return;
        link.dataset.pjaxBound = '1';
        link.addEventListener('click', function (e) {
          e.preventDefault();
          const href = link.getAttribute('href') || link.href;
          if (href) pjaxNavigate(href, container);
        });
      });

    // 2. Sort dropdown
    container.querySelectorAll('[data-pjax-sort]').forEach(function (sel) {
      if (sel.dataset.pjaxBound) return;
      sel.dataset.pjaxBound = '1';
      sel.addEventListener('change', function () {
        if (sel.value) pjaxNavigate(sel.value, container);
      });
    });

    // 3. Pagination & Cumulative Load More links
    container
      .querySelectorAll('.bfwt-pagination-container a, .nav-links a')
      .forEach(function (link) {
        if (link.dataset.noPjax === '1') return;
        if (link.dataset.pjaxBound) return;
        link.dataset.pjaxBound = '1';
        link.addEventListener('click', function (e) {
          e.preventDefault();
          const href = link.getAttribute('href') || link.href;
          const isAppend = link.dataset.pjaxAppend === '1';
          if (href) pjaxNavigate(href, container, { append: isAppend, scroll: !isAppend });
        });
      });

    // Center active pill inside horizontal pills rail
    const rail = container.querySelector('.bfwt-filter-bar__pills-rail');
    if (rail) {
      const activePill = rail.querySelector('.bfwt-filter-bar__toggle.is-active');
      if (activePill) {
        requestAnimationFrame(function () {
          const railRect = rail.getBoundingClientRect();
          const pillRect = activePill.getBoundingClientRect();
          const offset = pillRect.left - railRect.left - railRect.width / 2 + pillRect.width / 2;
          if (Math.abs(offset) > 12) {
            rail.scrollTo({ left: Math.max(0, rail.scrollLeft + offset), behavior: 'smooth' });
          }
        });
      }
    }

    // 4. Mobile drawer toggle
    container
      .querySelectorAll('.bfwt-filter-bar__mobile-toggle')
      .forEach(function (btn) {
        if (btn.dataset.pjaxBound) return;
        btn.dataset.pjaxBound = '1';
        btn.addEventListener('click', function () {
          const bar = btn.closest('.bfwt-filter-bar');
          if (bar) {
            const open = bar.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          }
        });
      });
  }

  // ── popstate (back / forward) ──
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.pjax && e.state.pjaxId) {
      const container = document.querySelector(
        '[data-pjax-id="' + CSS.escape(e.state.pjaxId) + '"]'
      );
      if (container) {
        pjaxNavigate(location.href, container, { push: false, scroll: false });
      }
    } else {
      // If state has no pjax flag, check if any container exists and reload it
      const containers = document.querySelectorAll(CONTAINER_SEL);
      if (containers.length) {
        containers.forEach(function (c) {
          pjaxNavigate(location.href, c, { push: false, scroll: false });
        });
      }
    }
  });

  // ── Session storage view mode: restore on first load if no URL param ──
  (function restoreViewMode() {
    // Skip on singular templates
    if (document.body.classList.contains('single') || document.body.classList.contains('wp-singular')) return;

    // Only run on pages that actually contain a PJAX grid container (archives/listings)
    if (!document.querySelector(CONTAINER_SEL)) return;

    let saved = null;
    try {
      saved = sessionStorage.getItem(VIEW_STORAGE_KEY);
    } catch (e) {}
    if (!saved || saved === 'vertical') return;
    const params = new URLSearchParams(location.search);
    if (params.has('view')) return; // URL already has a view param, server rendered correctly

    // Avoid redundant redirect on mobile category pages if the saved view is already horizontal
    // since horizontal is the default there.
    const isMobile = window.innerWidth <= 768;
    const isCategory = /brand-category|brand-collection/.test(location.pathname);
    if (isMobile && isCategory && saved === 'horizontal') return;

    // Redirect to apply saved view preference (one-time server render)
    params.set('view', saved);
    location.replace(
      location.pathname + '?' + params.toString() + location.hash
    );
  })();

  // ── Init ──
  function init() {
    document.querySelectorAll(CONTAINER_SEL).forEach(bindContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose globally for dynamic containers (like watchlist/your-brands grid)
  window.bfwtInitPjaxContainer = bindContainer;
})();
